import {lazy} from 'react';
import LazyComponent from 'components/LazyComponent';

const conversationKeywordRoutes = [
	{
		component: LazyComponent(lazy(() => import('./List'))),
		path: '/conversation-keyword/list/',
	},
];

export default conversationKeywordRoutes;
